<template>
  <div class="settled flex flex-row">
    <div class="flex-1">
      <SettledScroll :headType="1" :data="ents" @entry="settledEnt" />
    </div>
    <div class="flex-1 settled-center">
      <SettledScroll
        :headType="2"
        :data="labs"
        @entry="settledLab"
        @itemClick="toLab"
      />
    </div>
    <div class="flex-1">
      <SettledScroll
        :headType="3"
        :data="demands"
        @entry="releaseReq"
        @itemClick="toDemand"
      />
    </div>
  </div>
</template>
<script>
// import Scroll from "./Scroll.vue";
import { demandList } from "@/api/hall";
import { getUserLabInfo } from "@/api/userCenter";
import { settledNewEnt, settledNewLab } from "@/api/home";
import { mapGetters } from "vuex";
import { parseTime } from "@/utils/index";
import SettledScroll from "./SettledScroll.vue";
export default {
  components: {
    // Scroll,
    SettledScroll,
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 7,
      },
      demands: [],
      ents: [],
      labs: [],
    };
  },
  computed: {
    ...mapGetters(["token", "userBaseInfo"]),
  },
  created() {
    // 获取需求
    this.getDemandList();
    // 获取企业
    this.getEnt();
    // 获取实验室
    this.getLab();
  },
  methods: {
    async getEnt() {
      const { list } = await this.$axios.post(settledNewEnt, this.page);
      this.ents = list.map((item) => {
        return {
          title: item.enterpriseName,
          date: parseTime(item.createTimeStamp, "{yyyy}-{m}-{d}"),
        };
      });
    },
    async getLab() {
      const { list } = await this.$axios.post(settledNewLab, this.page);
      this.labs = list.map((item) => {
        return {
          title: item.laboratoryName,
          date: parseTime(item.createTimeStamp, "{yyyy}-{m}-{d}"),
          id: item.laboratoryId,
        };
      });
    },
    // 获取需求
    async getDemandList() {
      const { list } = await this.$axios.post(demandList, this.page);
      this.demands = list.map((item) => {
        return {
          title: item.demandProjectName,
          date: item.createTime,
          id: item.demandId,
        };
      });
    },
    addDemandClick() {},
    // 点击入驻实验室
    async settledLab() {
      if (this.token) {
        const isLab = await this.isJoinLab();
        if (isLab) {
          this.$message.warning("您已入驻实验室，不能重复入驻");
          return;
        }
        this.$jump.push({ name: "labRegister" });
      } else {
        this.$store.dispatch("login");
      }
    },
    // 发布检测需求
    releaseReq() {
      if (this.token) {
        this.$jump.push({ name: "releaseReq" });
      } else {
        this.$store.dispatch("login");
      }
    },
    // 入驻企业
    async settledEnt() {
      if (this.token) {
        if (this.isJoinEnt('"您已申请入驻企业，不能重复入驻"')) return;
        this.$jump.push({ name: "entRegister" });
      } else {
        this.$store.dispatch("login");
      }
    },
    isJoinEnt(msg) {
      const { isBusiness } = this.userBaseInfo;
      const isEnt = "1"; // 审核通过
      const entChecking = "2"; // 审核中
      if ([isEnt, entChecking].includes(isBusiness)) {
        this.$message.warning(msg);
        return true;
      }
      return false;
    },
    async isJoinLab() {
      const data = await this.$axios.get(getUserLabInfo);
      if (data && data.laboratoryId) {
        return true;
      }
      return false;
    },

    toLab(id) {
      this.$jump.push({
        name: "labDetail",
        query: {
          id,
        },
      });
    },
    toDemand(id) {
      this.$jump.push({
        name: "demandDetail",
        query: {
          id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.settle {
  width: 50%;
}
</style>
